import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const SchedulingPanel = ({ selectedDate, onSchedule, onCancel }) => {
  const [formData, setFormData] = useState({
    time: '',
    duration: '60',
    encounterType: '',
    location: '',
    notes: ''
  });

  const encounterTypes = [
    { value: 'romantic', label: 'Romantic & Intimate' },
    { value: 'passionate', label: 'Passionate & Energetic' },
    { value: 'playful', label: 'Playful & Experimental' },
    { value: 'relaxed', label: 'Relaxed & Comfortable' },
    { value: 'spontaneous', label: 'Spontaneous & Quick' }
  ];

  const durations = [
    { value: '30', label: '30 minutes' },
    { value: '60', label: '1 hour' },
    { value: '90', label: '1.5 hours' },
    { value: '120', label: '2 hours' },
    { value: '180', label: '3+ hours' }
  ];

  const locations = [
    { value: 'bedroom', label: 'Bedroom' },
    { value: 'living-room', label: 'Living Room' },
    { value: 'other-home', label: 'Other (Home)' },
    { value: 'hotel', label: 'Hotel/Getaway' },
    { value: 'other', label: 'Other Location' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!formData?.time || !formData?.encounterType) {
      return;
    }
    onSchedule({
      date: selectedDate,
      ...formData
    });
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Schedule Intimate Session
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            {formatDate(selectedDate)}
          </p>
        </div>
        <button
          onClick={onCancel}
          className="p-2 rounded-md hover:bg-muted transition-therapeutic"
          aria-label="Close scheduling panel"
        >
          <Icon name="X" size={20} color="var(--color-muted-foreground)" />
        </button>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5">
        <Input
          type="time"
          label="Preferred Time"
          required
          value={formData?.time}
          onChange={(e) => setFormData({ ...formData, time: e?.target?.value })}
        />

        <Select
          label="Duration"
          required
          options={durations}
          value={formData?.duration}
          onChange={(value) => setFormData({ ...formData, duration: value })}
        />

        <Select
          label="Encounter Type"
          description="Your preference will be shared with AI for matching"
          required
          options={encounterTypes}
          value={formData?.encounterType}
          onChange={(value) => setFormData({ ...formData, encounterType: value })}
        />

        <Select
          label="Location Preference"
          options={locations}
          value={formData?.location}
          onChange={(value) => setFormData({ ...formData, location: value })}
        />

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Private Notes
            <span className="text-muted-foreground ml-2 font-normal">
              (Only visible to AI)
            </span>
          </label>
          <textarea
            value={formData?.notes}
            onChange={(e) => setFormData({ ...formData, notes: e?.target?.value })}
            placeholder="Share any specific desires or preferences..."
            rows={3}
            className="w-full px-3 py-2 rounded-md border border-input bg-background text-foreground text-sm resize-none focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>

        <div className="bg-muted/50 rounded-md p-3 md:p-4">
          <div className="flex items-start space-x-2">
            <Icon name="Lock" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs md:text-sm text-muted-foreground">
              Your preferences remain private until AI finds compatible timing with your partner's mood and availability.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Button
            type="submit"
            variant="default"
            iconName="Calendar"
            iconPosition="left"
            fullWidth
          >
            Schedule Session
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            fullWidth
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SchedulingPanel;